import type { Permission } from '@jaf/contracts';
import type { ReactNode } from 'react';
import { Outlet } from 'react-router';
import { ForbiddenPage } from '@/shared/ui/feedback';
import { useCan } from './use-can';

/**
 * Elemento de rota que protege as rotas filhas por permissão: sem ela no escopo selecionado,
 * mostra "Acesso negado" dentro do layout (e reage à troca de escopo). Os loaders das filhas
 * usam `requirePermission` (de `@/features/auth`) para não pré-carregar dados sem permissão.
 */
export function RequirePermission({ permission }: { permission: Permission }): ReactNode {
  return useCan()(permission) ? <Outlet /> : <ForbiddenPage />;
}
